module.exports = __webpack_public_path__ + "static/img/rtov.78a3a64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rtov.jpg
// module id = 188
// module chunks = 1